import React, { useState } from 'react';
import { MapPin, ChevronRight, CheckCircle2, Printer, Save, AlertCircle, Search, Plus, Edit2, Trash2, Check, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const initialLocations = ['Walk In', 'Prep Station', 'Freezer 1', 'Freezer 2', 'Fry Stations', 'Expedite Stations', 'Sautee Oven Station', 'Expo Station', 'Dish Area', 'Liquor Room', 'Liquor Cage', 'Main Bar', 'Bar Cooler 1', 'Bar Cooler 2'];
export function LocationCount() {
  const [locations, setLocations] = useState(initialLocations);
  const [selectedLocation, setSelectedLocation] = useState(locations[0]);
  const [isAdding, setIsAdding] = useState(false);
  const [newLocationName, setNewLocationName] = useState('');
  const [editingLoc, setEditingLoc] = useState<string | null>(null);
  const [editValue, setEditValue] = useState('');
  const handleAddLocation = () => {
    if (newLocationName.trim()) {
      setLocations([...locations, newLocationName.trim()]);
      setNewLocationName('');
      setIsAdding(false);
    }
  };
  const handleDeleteLocation = (locToDelete: string) => {
    const updated = locations.filter(l => l !== locToDelete);
    setLocations(updated);
    if (selectedLocation === locToDelete) {
      setSelectedLocation(updated[0] || '');
    }
  };
  const handleStartEdit = (loc: string) => {
    setEditingLoc(loc);
    setEditValue(loc);
  };
  const handleSaveEdit = () => {
    if (editValue.trim() && editingLoc) {
      const updated = locations.map(l => l === editingLoc ? editValue.trim() : l);
      setLocations(updated);
      if (selectedLocation === editingLoc) {
        setSelectedLocation(editValue.trim());
      }
      setEditingLoc(null);
    }
  };
  const [isPrintMode, setIsPrintMode] = useState(false);
  return <div className="space-y-6" data-id="element-645">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-646">
        <div className="flex items-center gap-3" data-id="element-647">
          <div className="p-2 bg-emerald-50 rounded-xl text-emerald-600" data-id="element-648">
            <MapPin size={20} data-id="element-649" />
          </div>
          <div data-id="element-650">
            <h3 className="text-lg font-bold text-slate-900" data-id="element-651">
              Physical Count by Location
            </h3>
            <p className="text-xs text-slate-500 font-medium" data-id="element-652">
              Select a location to start counting
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2" data-id="element-653">
          <button onClick={() => setIsPrintMode(!isPrintMode)} className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-bold transition-all shadow-sm border ${isPrintMode ? 'bg-slate-900 text-white border-slate-900' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`} data-id="element-654">
            <Printer size={16} data-id="element-655" />
            {isPrintMode ? 'Exit Print Mode' : 'Print Count Sheet'}
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-656">
            <Save size={16} data-id="element-657" />
            Save Progress
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-658">
        <div className="md:col-span-1 space-y-4" data-id="element-659">
          <div className="flex items-center justify-between px-2" data-id="element-660">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-661">
              Locations
            </p>
            <button onClick={() => setIsAdding(true)} className="p-1 text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors" data-id="element-662">
              <Plus size={14} data-id="element-663" />
            </button>
          </div>

          <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden p-2 space-y-1" data-id="element-664">
            <AnimatePresence initial={false} data-id="element-665">
              {isAdding && <motion.div initial={{
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={{
              opacity: 0,
              height: 0
            }} className="px-2 py-2 border-b border-slate-50 mb-2" data-id="element-666">
                  <div className="flex items-center gap-2" data-id="element-667">
                    <input autoFocus type="text" placeholder="Location name..." className="flex-1 px-2 py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-xs font-bold outline-none focus:border-emerald-500" value={newLocationName} onChange={e => setNewLocationName(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleAddLocation()} data-id="element-668" />
                    <button onClick={handleAddLocation} className="p-1.5 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600" data-id="element-669">
                      <Check size={12} data-id="element-670" />
                    </button>
                    <button onClick={() => setIsAdding(false)} className="p-1.5 bg-slate-100 text-slate-500 rounded-lg hover:bg-slate-200" data-id="element-671">
                      <X size={12} data-id="element-672" />
                    </button>
                  </div>
                </motion.div>}
            </AnimatePresence>

            {locations.map(loc => <div key={loc} className={`group relative flex items-center rounded-xl transition-all ${selectedLocation === loc ? 'bg-emerald-50 text-emerald-700 shadow-sm' : 'text-slate-500 hover:bg-slate-50'}`} data-id="element-673">
                {editingLoc === loc ? <div className="flex-1 flex items-center gap-1 p-1" data-id="element-674">
                    <input autoFocus type="text" className="flex-1 px-2 py-1 bg-white border border-emerald-200 rounded-lg text-xs font-bold outline-none" value={editValue} onChange={e => setEditValue(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSaveEdit()} data-id="element-675" />
                    <button onClick={handleSaveEdit} className="p-1 text-emerald-600 hover:bg-emerald-100 rounded-md" data-id="element-676">
                      <Check size={12} data-id="element-677" />
                    </button>
                    <button onClick={() => setEditingLoc(null)} className="p-1 text-slate-400 hover:bg-slate-100 rounded-md" data-id="element-678">
                      <X size={12} data-id="element-679" />
                    </button>
                  </div> : <>
                    <button onClick={() => setSelectedLocation(loc)} className="flex-1 flex items-center justify-between px-3 py-2 text-xs font-bold text-left" data-id="element-680">
                      {loc}
                      {selectedLocation === loc && <ChevronRight size={14} data-id="element-681" />}
                    </button>
                    <div className="absolute right-2 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity bg-inherit pl-2" data-id="element-682">
                      <button onClick={e => {
                  e.stopPropagation();
                  handleStartEdit(loc);
                }} className="p-1 text-slate-400 hover:text-emerald-600 hover:bg-white rounded-md transition-colors" data-id="element-683">
                        <Edit2 size={12} data-id="element-684" />
                      </button>
                      <button onClick={e => {
                  e.stopPropagation();
                  handleDeleteLocation(loc);
                }} className="p-1 text-slate-400 hover:text-rose-600 hover:bg-white rounded-md transition-colors" data-id="element-685">
                        <Trash2 size={12} data-id="element-686" />
                      </button>
                    </div>
                  </>}
              </div>)}
          </div>
        </div>

        <div className="md:col-span-3 space-y-4" data-id="element-687">
          <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-688">
            <div className="p-4 border-b border-slate-50 flex items-center justify-between bg-slate-50/30" data-id="element-689">
              <h4 className="text-sm font-bold text-slate-900" data-id="element-690">
                {selectedLocation} Inventory
              </h4>
              <div className="flex items-center gap-2" data-id="element-691">
                <span className="px-2 py-1 bg-amber-50 text-amber-600 text-[10px] font-bold rounded uppercase" data-id="element-692">
                  8 Items Pending
                </span>
                <button className="text-emerald-600 text-[10px] font-bold hover:underline uppercase" data-id="element-693">
                  Mark All Complete
                </button>
              </div>
            </div>
            <div className="overflow-x-auto" data-id="element-694">
              <table className="w-full text-left border-collapse" data-id="element-695">
                <thead data-id="element-696">
                  <tr className="border-b border-slate-100" data-id="element-697">
                    <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-698">
                      Item
                    </th>
                    <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-699">
                      On Hand
                    </th>
                    {!isPrintMode && <>
                        <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-700">
                          PAR
                        </th>
                        <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-701">
                          Order
                        </th>
                      </>}
                    <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-702">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-50" data-id="element-703">
                  {[1, 2, 3, 4, 5].map(i => <tr key={i} className="hover:bg-slate-50/50 transition-colors" data-id="element-704">
                      <td className="px-6 py-4" data-id="element-705">
                        <p className="text-sm font-bold text-slate-900" data-id="element-706">
                          Inventory Item {i}
                        </p>
                        <p className="text-[10px] text-slate-400 font-medium" data-id="element-707">
                          Pound
                        </p>
                      </td>
                      <td className="px-6 py-4" data-id="element-708">
                        <div className="flex justify-center" data-id="element-709">
                          <input type="number" placeholder="0" className="w-20 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-center text-sm font-bold focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all" data-id="element-710" />
                        </div>
                      </td>
                      {!isPrintMode && <>
                          <td className="px-6 py-4 text-center text-sm font-bold text-slate-500" data-id="element-711">
                            10
                          </td>
                          <td className="px-6 py-4 text-center text-sm font-black text-emerald-600" data-id="element-712">
                            0
                          </td>
                        </>}
                      <td className="px-6 py-4 text-right" data-id="element-713">
                        <div className="flex justify-end" data-id="element-714">
                          <div className="w-6 h-6 rounded-full border-2 border-slate-200 flex items-center justify-center text-slate-200 cursor-pointer hover:border-emerald-500 hover:text-emerald-500 transition-all" data-id="element-715">
                            <CheckCircle2 size={14} data-id="element-716" />
                          </div>
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
            <div className="p-6 border-t border-slate-50 flex justify-end" data-id="element-717">
              <button className="px-8 py-3 bg-slate-900 text-white rounded-xl text-sm font-bold hover:bg-slate-800 transition-all shadow-lg shadow-slate-900/20" data-id="element-718">
                Confirm Count & Approve
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}